import axios from "../axios";
import Notification from "@/inside/models/Notification";

export default {
    actions: {
        /**
         * Initializes VueX module.
         *
         * @param {function} commit
         */
        init({commit}) {
            axios.get("/my/notifications", {
                validateStatus: (status => status === 200)
            }).then((response) => {
                if (typeof response.data === "object") {
                    response.data.forEach((notification_data) => {
                        commit("add", Notification.fromAPI(notification_data))
                    });
                }
            });
        },
        /**
         * @param {function} commit
         * @param {object} payload
         */
        view({commit}, payload) {
            if (!(payload instanceof Notification)) {
                throw new TypeError(`VueX 'notifications/view' action expects payload to be an instance of Notification, ${typeof payload} given`);
            }

            axios.patch(`/notifications/${payload.id}`, null, {
                validateStatus: (status => status === 200)
            }).then(() => {
                commit("setAsViewed", payload.id);
            });
        }
    },
    getters: {
        /**
         * Returns all notifications currently stored in module state, sorted from most recent to oldest.
         *
         * @param {state} state
         * @returns {Notification[]}
         */
        all(state){
            return state.notifications
        }
    },
    mutations: {
        /**
         * Adds given `notification` to module state.
         *
         * @param {object} state
         * @param {Notification} notification
         */
        add(state, notification){
            state.notifications.push(notification);
            state.notifications.sort((notificationA, notificationB) => {
                return notificationB.date.valueOf() - notificationA.date.valueOf();
            });
        },
        /**
         * Switches notification with given `notification_id` to "viewed" in module state.
         *
         * @param {object} state
         * @param {String} notification_id
         */
        setAsViewed(state, notification_id) {
            for (let i = 0; i < state.notifications.length; i++) {
                if (state.notifications[i].id === notification_id) {
                    state.notifications[i].isViewed = true;
                    break;
                }
            }
        }
    },
    namespaced: true,
    state: {
        notifications: []
    }
}
